import { createTheme } from '@mui/material/styles';

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: '#F99712',
      dark: '#1c1c1c',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#4a4a4a',
    },
    error: {
      main: '#c42210',
    },
    ...(mode === 'dark'
      ? {
          background: {
            default: '#121212',
            paper: '#1e1e1e',
          },
          text: {
            primary: '#ffffff',
            secondary: 'rgba(255, 255, 255, 0.7)',
          },
        }
      : {
          background: {
            default: '#f5f5f5',
            paper: '#ffffff',
          },
          text: {
            primary: '#1c1c1c',
            secondary: 'rgba(0, 0, 0, 0.6)',
          },
        }),
  },
  typography: {
    fontFamily: 'quicksand, sans-serif',
    body2: {
      fontFamily: 'audiowide, sans-serif',
      fontSize: 16,
    },
    h5: {
      fontFamily: 'audiowide, sans-serif',
    },
    h6: {
      fontFamily: 'audiowide, sans-serif',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'audiowide, sans-serif',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

export const createAppTheme = (mode) => createTheme(getDesignTokens(mode));

// Default export for backwards compatibility
export default createTheme(getDesignTokens('dark'));
